import React from 'react'
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import './DownloadButtons.css'
import { useLanguage } from "../../contexts/LanguageContext";

function DownloadButtons() {
    const { translations: t } = useLanguage();
  
  return (
     <div className="download-buttons">
                <a  href="https://apps.apple.com/ao/app/iwinto/id6482291656"                
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="store-button apple">
                  <FaApple className="icon-apple" />
                  <div>
                    <span>{t.downloadOn || "Download On"}</span>
                    <strong>{t.appStore || "App Store"}</strong>
                  </div>
                </a>
                <a  href="https://play.google.com/store/apps/details?id=com.winto.app" 
                    target="_blank" 
                    rel="noopener noreferrer" className="store-button google">
                  <FaGooglePlay className="icon" />
                  <div>
                   <span>{t.downloadOn || "Download On"}</span>
                   <strong>{t.playStore || "Play Store"}</strong>
                  </div>
                </a>
              </div>
  )
}

export default DownloadButtons